import { render, staticRenderFns } from "./ehc-alert-confirm.vue?vue&type=template&id=51152b76"
import script from "./ehc-alert-confirm.vue?vue&type=script&lang=js"
export * from "./ehc-alert-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports